var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29586 6.84C7.13586 7 6.95186 7.08 6.74386 7.08C6.55186 7.08 6.37586 7.008 6.21586 6.864C6.07186 6.704 5.99986 6.52 5.99986 6.312C5.99986 6.104 6.07186 5.928 6.21586 5.784L11.9999 0L17.8079 5.784C17.9519 5.928 18.0239 6.104 18.0239 6.312C18.0239 6.52 17.9519 6.696 17.8079 6.84C17.6159 7 17.4239 7.08 17.2319 7.08C17.0559 7.08 16.8879 7 16.7279 6.84L12.7679 2.88V16.632H11.2559V2.88L7.29586 6.84ZM5.25586 24V22.512H18.7439V24H5.25586Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWhite);
export default __webpack_public_path__ + "static/media/upload-white.de9c335df84b040ca246d4bc819ff7ba.svg";
export { ForwardRef as ReactComponent };